import { QuestionnaireProps } from './Questionnaire';
import { QuestionnaireConfiguration, QuestionnaireQuestions } from '../models';
import { mergeConfiguration } from '../utils/mergeConfiguration';

export type CreateQuestionnaireType<ExtendedProps = {}> = <
  Questionnaire extends QuestionnaireQuestions,
  GroupId,
  ExtendedComponentTypes,
  SignupSpecificComponents extends string
>(
  props: Omit<
    QuestionnaireProps<Questionnaire, GroupId, ExtendedComponentTypes>,
    'configuration'
  > & {
    configuration: Omit<ExtendedComponentTypes, SignupSpecificComponents>;
  } & ExtendedProps
) => JSX.Element;

export const createQuestionnaire = <
  BaseConfiguration extends Partial<Record<string, unknown>>,
  Questionnaire extends QuestionnaireQuestions,
  GroupId,
  ExtendedComponentTypes,
  Props = QuestionnaireProps<
    Questionnaire,
    GroupId,
    ExtendedComponentTypes & BaseConfiguration
  >
>(
  baseConfiguration: BaseConfiguration,
  Component: (props: Props) => JSX.Element
) => {
  return ({
    configuration,
    ...props
  }: {
    configuration?: QuestionnaireConfiguration<
      Questionnaire,
      Omit<ExtendedComponentTypes, keyof BaseConfiguration['components']>
    >;
  } & Omit<Props, 'configuration'>) => {
    return (
      <Component
        {...(props as Props)}
        configuration={
          configuration
            ? mergeConfiguration(baseConfiguration, configuration)
            : baseConfiguration
        }
      />
    );
  };
};
